import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import FooterLayout from './footer';
import TopTicker from './TopTicker';
import tickerService from '../services/ticker-service';

const { Content } = Layout;

export default function AuthLayout({ children }) {
    const location = useLocation()
    const [tickerMessages, setTickerMessages] = useState([]);
    const [showTicker, setShowTicker] = useState(true);

    const loadTicker = async () => {
        const { success, data } = await tickerService.fetchLoginPageTicker();

        if (success) {
            const messages = data.map(item => item.message);
            setTickerMessages(messages);
        }
    };
    useEffect(() => {
        loadTicker();
    }, [])
    return (
        <Layout style={{ minHeight: "100vh" }}>
            {showTicker && (
                <TopTicker
                    text={tickerMessages}
                    onclose={() => setShowTicker(false)}
                />
            )}
            <Layout className="site-layout flex flex-col max-w-4xl mx-auto justify-center ">
                {/* Header */}
                <div className="flex justify-between items-center mt-6 mb-4">
                    <img
                        src="/images/Houston.png"
                        alt="ctrade-Logo"
                        style={{ width: "180px", height: "50px" }}
                    />
                    <div className="flex gap-3 items-center p-0 m-0">
                        <Link
                            to={"/login"}
                            className={`${location.pathname === "/login"
                                ? "text-primary font-extrabold"
                                : "text-gray-600"
                                } hover:text-primary`}
                        >
                            Login
                        </Link>
                        <span>|</span>
                        <Link
                            to={"/signup"}
                            className={`${location.pathname === "/signup"
                                ? "text-primary font-bold"
                                : "text-gray-600"
                                } hover:text-primary`}
                        >
                            Register
                        </Link>
                    </div>
                </div>

                {/* Content with flex-grow pushes footer down */}
                <Content className="flex justify-center items-center ">{children}</Content>

                {/* Footer */}
                <div className="mb-5">
                    <FooterLayout />
                </div>
            </Layout>

        </Layout>

    )
}